/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import {
  MotifModal,
  MotifModalHeader,
  MotifModalBody,
  MotifTheme,
  MotifModalFooter,
  MotifButton,
  MotifErrorMessage,
} from "@ey-xd/motif-react";
import "./ArtifactDeleteModal.scss";
// Import icon                      
import { MotifIcon } from '@ey-xd/motif-react';
import { IconoirWarningCircle } from '@ey-xd/motif-icon';
import { ArtifactType } from "../../pages/CTProductCostSetup/CTProductCostSetup";
import Loader from "../Loader";
import { DELETE_DOCUMENT_CONFIRMATION_MASSAGE, SOMTHING_WENT_WRONG } from "../../Constant";

interface ArtifactDeleteModalProps {
  show: boolean;
  setShow: (show: boolean) => void;
  setArtifactDeleteModalItem: React.Dispatch<React.SetStateAction<ArtifactType | null>>;
  handleDeleteArtifactConfirm: (item: ArtifactType | null) => Promise<void>;
  artifactDeleteModalItem: ArtifactType | null;
  isArtifactsDeleteLoading: boolean;
  setIsArtifactsDeleteError: React.Dispatch<React.SetStateAction<boolean>>;
  isArtifactsDeleteError: boolean;
}

export default function ArtifactDeleteModal({
  show = true,
  setShow,
  setArtifactDeleteModalItem,
  handleDeleteArtifactConfirm,
  artifactDeleteModalItem,
  isArtifactsDeleteLoading,
  setIsArtifactsDeleteError,
  isArtifactsDeleteError

}: ArtifactDeleteModalProps) {
  useEffect(() => {
    if (show) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [show]);


  return (
    <div className="artifact-delete-modal">
      <MotifTheme variant={"light"}></MotifTheme>
      <MotifModal
        className="artifactDeleteModal"
        id="ArtifactDeleteModal"
        show={show}
        onClose={() => {
          setShow(false);
          setArtifactDeleteModalItem(null);
          setIsArtifactsDeleteError(false);
        }}
        focusTrapOptions={{
          tabbableOptions: {
            displayCheck: "none",
          },
        }}
      >
        <>
          <MotifModalHeader>
            <div className="warning-icon-circle">
              <MotifIcon iconFunction={IconoirWarningCircle} size="24" fill={"#FF4336"} strokeWidth="24" />
            </div>
          </MotifModalHeader>
          <MotifModalBody>
            {
              isArtifactsDeleteLoading && <Loader />
            }
            <div className="motif-col-lg-12  content-headeing">
              Delete {artifactDeleteModalItem?.Title}?
            </div>
            <div className="motif-col-lg-12  content">
              {DELETE_DOCUMENT_CONFIRMATION_MASSAGE}
            </div>
            {
              isArtifactsDeleteError && (
                <div className="error">
                  <MotifErrorMessage>
                    {SOMTHING_WENT_WRONG}
                  </MotifErrorMessage>
                </div>
              )
            }
          </MotifModalBody>
          <MotifModalFooter>
            <MotifButton
              variant={"secondary"}
              onClick={() => {
                setShow(false);
                setIsArtifactsDeleteError(false);
              }}
            >
              Cancel
            </MotifButton>
            <MotifButton
              variant={"primary"}
              onClick={() => handleDeleteArtifactConfirm(artifactDeleteModalItem ? artifactDeleteModalItem : null)}
              className="approveButton"
            >
              {"Delete"}
            </MotifButton>
          </MotifModalFooter>
        </>
      </MotifModal>
    </div>
  );
}